/** Canonical test-level metadata introduced by IELTS-265/266. */

export type ExamType = 'full_practice_test' | 'section_practice_test' | 'mock_exam'
export type IeltsModule = 'academic' | 'general_training' | 'both'

export const EXAM_TYPE_OPTIONS: ReadonlyArray<{ value: ExamType; label: string }> = [
  { value: 'full_practice_test', label: 'Full Practice Test' },
  { value: 'section_practice_test', label: 'Section Practice Test' },
  { value: 'mock_exam', label: 'Mock Exam' },
]

export const IELTS_MODULE_OPTIONS: ReadonlyArray<{ value: IeltsModule; label: string }> = [
  { value: 'academic', label: 'Academic' },
  { value: 'general_training', label: 'General Training' },
  { value: 'both', label: 'Suitable for Both' },
]

export const UNCLASSIFIED_EXAM_TYPE_LABEL = 'Exam type not classified'
export const UNCLASSIFIED_IELTS_MODULE_LABEL = 'IELTS module not classified'
export const UNCLASSIFIED_FILTER = 'unclassified'

export type ExamTypeFilter = ExamType | typeof UNCLASSIFIED_FILTER
export type IeltsModuleFilter = IeltsModule | typeof UNCLASSIFIED_FILTER

export function readExamType(value: unknown): ExamType | null {
  return EXAM_TYPE_OPTIONS.some((option) => option.value === value) ? value as ExamType : null
}

export function readIeltsModule(value: unknown): IeltsModule | null {
  return IELTS_MODULE_OPTIONS.some((option) => option.value === value) ? value as IeltsModule : null
}

export function readExamTypeFilter(value: unknown): ExamTypeFilter | null {
  if (value === UNCLASSIFIED_FILTER) return UNCLASSIFIED_FILTER
  return readExamType(value)
}

export function readIeltsModuleFilter(value: unknown): IeltsModuleFilter | null {
  if (value === UNCLASSIFIED_FILTER) return UNCLASSIFIED_FILTER
  return readIeltsModule(value)
}

export function examTypeLabel(value: ExamType | null | undefined): string {
  return EXAM_TYPE_OPTIONS.find((option) => option.value === value)?.label ?? UNCLASSIFIED_EXAM_TYPE_LABEL
}

export function ieltsModuleLabel(value: IeltsModule | null | undefined): string {
  return IELTS_MODULE_OPTIONS.find((option) => option.value === value)?.label ?? UNCLASSIFIED_IELTS_MODULE_LABEL
}
